import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarLancamentoConsignatarioModel } from "../models/lancamentoConsignatario/buscarLancamentoConsignatarioModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarLancamentoConsignatario, setModalDeletarLancamentoConsignatario } from "../redux/slices/lancamentoConsignatario/lancamentoConsignatarioSlice";
import { listarSaldoConsignatario } from "./prestacaoContaService";

export const cadastrarLancamentoConsignatario = createAsyncThunk("/LancamentoConsignatario/CadastrarLancamentoConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/LancamentoConsignatario/CadastrarLancamentoConsignatario", payload.value);
    toastSucess("Lançamento avulso cadastrado com sucesso");
    dispatch(setModalCadastrarLancamentoConsignatario(false));
    dispatch(setLoading(false));

    dispatch(listarLancamentoConsignatario(payload.buscaLancamento));
    dispatch(listarSaldoConsignatario(payload.buscaPrestacao));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const listarLancamentoConsignatario = createAsyncThunk("/PrestacaoContaConsignatario/ListarLancamentoConsignatario", async (args: BuscarLancamentoConsignatarioModel) => {
  try {
    const data = await api.get("/LancamentoConsignatario/ListarLancamentoConsignatario", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarLancamentoConsignatario = createAsyncThunk("/LancamentoConsignatario/AtualizarLancamentoConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/LancamentoConsignatario/AtualizarLancamentoConsignatario", payload.value);
    toastSucess("Lançamento avulso atualizado com sucesso");
    dispatch(setModalCadastrarLancamentoConsignatario(false));
    dispatch(setLoading(false));

    dispatch(listarLancamentoConsignatario(payload.buscaLancamento));
    dispatch(listarSaldoConsignatario(payload.buscaPrestacao));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const removerLancamentoConsignatario = createAsyncThunk("/LancamentoConsignatario/RemoverLancamentoConsignatario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/LancamentoConsignatario/RemoverLancamentoConsignatario", payload.value);
    toastSucess("Lançamento avulso removido com sucesso");
    dispatch(setModalDeletarLancamentoConsignatario(false));
    dispatch(setLoading(false));

    dispatch(listarLancamentoConsignatario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
